// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__114B7","legacyBtn":"MutateMid_legacyBtn__3j2Ol"};